module.exports = __webpack_public_path__ + "overlook-studios/media/scanlines_original.mp4";